// extracted by mini-css-extract-plugin
module.exports = {"team-item":"team-item","team-text":"team-text"};